<header>
  <h1>
    <a href="/"><img src="/assets/img/Yugibrary-logo.png" alt="logo de Yugibrary" /></a>
  </h1>
  <!-- <app-login-component style="position: absolute; top: 0; right: 0; height: 6%;"></app-login-component> -->
</header>
